import React from 'react';
import PropTypes from 'prop-types';
import { registerField } from 'core/forms';

import { Typo } from 'uikit/content';
import { Breadcrumbs } from 'uikit/layouts';

import styles from '../styles/formFieldShortcutsList.module.scss';

const FormFieldShortcutsList = ({ fieldId, schema, value = [] }) => (
  <div id={fieldId}>
    {value?.length > 0 ? (
      /* eslint-disable react/no-array-index-key */
      value.map((breadcrumbs, i) => (
        <Breadcrumbs
          key={i}
          className={styles.shortcutLocation}
          breadcrumbs={breadcrumbs}
          shouldShowAllAsActive
        />
      ))
    ) : (
      /* eslint-enable react/no-array-index-key */
      <Typo variant="s01" weight="medium">
        {schema.emptyStateText}
      </Typo>
    )}
  </div>
);

FormFieldShortcutsList.propTypes = {
  fieldId: PropTypes.string.isRequired,
  schema: PropTypes.shape({}).isRequired,
  value: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.shape({}))),
};

registerField('ShortcutsList', React.memo(FormFieldShortcutsList));

export default FormFieldShortcutsList;
